import { call, put, takeLatest, all } from "redux-saga/effects";
import * as types from "./actionTypes";
import { post } from "helpers/api_helper";

// Common Function Generator
function* commonReportSaga(action, successType, failureType, api) {
  try {
    const response = yield call(post, api, action.payload);
    if (response.status !== "success") throw new Error(response.message);
    yield put({ type: successType, payload: response.data });
  } catch (error) {
    yield put({ type: failureType, payload: error.message });
  }
}

// Watchers
function* watchAttendanceReportSagas() {

  // Consolidated Attendance
  yield takeLatest(types.FETCH_ATTENDANCE_CONSOLIDATED_REPORT_REQUEST, function* (action) {
    yield* commonReportSaga(
      action,
      types.FETCH_ATTENDANCE_CONSOLIDATED_REPORT_SUCCESS,
      types.FETCH_ATTENDANCE_CONSOLIDATED_REPORT_FAILURE,
      process.env.REACT_APP_ATTENDANCE_CONSOLIDATED_REPORT
    );
  });

  // Day Wise Attendance
  yield takeLatest(types.FETCH_DAY_WISE_ATTENDANCE_REPORT_REQUEST, function* (action) {
    yield* commonReportSaga(
      action,
      types.FETCH_DAY_WISE_ATTENDANCE_REPORT_SUCCESS,
      types.FETCH_DAY_WISE_ATTENDANCE_REPORT_FAILURE,
      process.env.REACT_APP_DAY_WISE_ATTENDANCE_REPORT
    );
  });

  // Late Attendance
  yield takeLatest(types.FETCH_LATE_ATTENDANCE_REPORT_REQUEST, function* (action) {
    yield* commonReportSaga(
      action,
      types.FETCH_LATE_ATTENDANCE_REPORT_SUCCESS,
      types.FETCH_LATE_ATTENDANCE_REPORT_FAILURE,
      process.env.REACT_APP_LATE_ATTENDANCE_REPORT
    );
  });

  yield takeLatest(
    types.FETCH_ABSENTEEISM_REPORT_REQUEST, 
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_ABSENTEEISM_REPORT_SUCCESS,
        types.FETCH_ABSENTEEISM_REPORT_FAILURE,
        process.env.REACT_APP_ABSENTEEISM_REPORT 
      );
    }
  );

   yield takeLatest(
    types.FETCH_EXTRA_HOURS_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_EXTRA_HOURS_REPORT_SUCCESS,
        types.FETCH_EXTRA_HOURS_REPORT_FAILURE,
        process.env.REACT_APP_EXTRA_HOURS_REPORT 
      );
    }
  );

  yield takeLatest(
    types.GET_MOBILE_PUNCH_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.GET_MOBILE_PUNCH_REPORT_SUCCESS,
        types.GET_MOBILE_PUNCH_REPORT_FAILURE,
        process.env.REACT_APP_MOBILE_PUNCH_REPORT
      );
    }
  );

  yield takeLatest(
    types.FETCH_LEAVE_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_LEAVE_REPORT_SUCCESS,
        types.FETCH_LEAVE_REPORT_FAILURE,
        process.env.REACT_APP_LEAVE_REPORT 
      );
    }
  );

  // Employee Shift Report
  yield takeLatest(
    types.FETCH_SHIFT_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_SHIFT_REPORT_SUCCESS,
        types.FETCH_SHIFT_REPORT_FAILURE,
        process.env.REACT_APP_SHIFT_REPORT
      );
    }
  );

  // Shift Details Report
  yield takeLatest(
    types.FETCH_SHIFT_DETAILS_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_SHIFT_DETAILS_REPORT_SUCCESS,
        types.FETCH_SHIFT_DETAILS_REPORT_FAILURE,
        process.env.REACT_APP_SHIFT_DETAILS_REPORT
      );
    }
  );

  // Shift Log Report
  yield takeLatest(
    types.FETCH_SHIFT_LOG_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_SHIFT_LOG_REPORT_SUCCESS,
        types.FETCH_SHIFT_LOG_REPORT_FAILURE,
        process.env.REACT_APP_SHIFT_LOG_REPORT
      );
    }
  );

  yield takeLatest(
    types.FETCH_LEAVE_BALANCE_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_LEAVE_BALANCE_REPORT_SUCCESS,
        types.FETCH_LEAVE_BALANCE_REPORT_FAILURE,
        process.env.REACT_APP_LEAVE_BALANCE_REPORT
      );
    }
  );

   yield takeLatest(
    types.FETCH_FORM6_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_FORM6_REPORT_SUCCESS,
        types.FETCH_FORM6_REPORT_FAILURE,
        process.env.REACT_APP_FORM6_REPORT
      );
    }
  );

  yield takeLatest(
    types.FETCH_FORM34_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_FORM34_REPORT_SUCCESS,
        types.FETCH_FORM34_REPORT_FAILURE,
        process.env.REACT_APP_FORM34_REPORT
      );
    }
  );

  yield takeLatest(
    types.FETCH_BREAKIN_REPORT_REQUEST,
    function* (action) {
      yield* commonReportSaga(
        action,
        types.FETCH_BREAKIN_REPORT_SUCCESS,
        types.FETCH_BREAKIN_REPORT_FAILURE,
        process.env.REACT_APP_BREAKIN_REPORT
      );
    }
  );
}

export default function* attendanceReportSaga() {
  yield all([watchAttendanceReportSagas()]);
}
